import { setContext } from '@apollo/client/link/context';
import posthog from 'posthog-js';

export const authLink = setContext((_, { headers }) => {
  // get the token from the URL
  const match = /\/l\/(\w+)/.exec(location.pathname);
  if (!match) throw new Error('No auth token found in the URL');
  let token = match[1];

  const newToken = sessionStorage.getItem('token');

  if (newToken) {
    token = newToken;
  }

  const sessionId = posthog.get_session_id?.();

  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: `Bearer ${token}`,
      ...(sessionId && { 'X-Posthog-Session-Id': sessionId })
    }
  };
});
